"use strict";

// oxlint-disable no-underscore-dangle, no-missing-message-target-origin
import { BridgeCore } from "./bridge_core.js";
import { BRIDGE_VERSION } from "./version.js";

// Subset of window.__pcaBridge that bridge_web.ts needs.

const INBOUND_TYPES = ['__bridge/call', '__bridge/response', '__bridge/exposed', '__bridge/unexposed', '__bridge/publish'];
export class WebBridge extends BridgeCore {
  constructor(options = {}) {
    const bus = window.__pcaBridge;
    super({
      send: msg => {
        if (window.ReactNativeWebView) {
          try {
            window.ReactNativeWebView.postMessage(JSON.stringify(msg));
          } catch (error) {
            options.logger?.error('WebBridge postMessage failed', {
              error
            });
          }
        }
      },
      logger: options.logger,
      defaultTimeoutMs: options.defaultTimeoutMs
    });
    this.bus = bus;
    this.handlerFn = msg => {
      this.handleIncomingMessage(msg);
    };
    if (bus) {
      if (options.logger) {
        bus.setLogger(options.logger);
      }
      for (const type of INBOUND_TYPES) {
        bus.register(type, this.handlerFn);
      }
      if (window.ReactNativeWebView) {
        try {
          window.ReactNativeWebView.postMessage(JSON.stringify({
            type: '__bridge/busReady',
            bridgeVersion: BRIDGE_VERSION
          }));
        } catch (error) {
          options.logger?.error('WebBridge busReady post failed', {
            error
          });
        }
      }
    } else {
      options.logger?.warn('WebBridge constructed without window.__pcaBridge — bus init script may not have run');
    }
  }
  applyLogger(logger) {
    const applied = super.applyLogger(logger);
    if (applied && this.bus) {
      this.bus.setLogger(logger);
    }
    return applied;
  }
  dispose() {
    if (this.bus) {
      for (const type of INBOUND_TYPES) {
        this.bus.unregister(type, this.handlerFn);
      }
    }
    super.dispose();
  }
}
export function createWebBridge(options = {}) {
  return new WebBridge(options);
}
export function getOrCreateWebBridge(options = {}) {
  if (window.__pcaWebBridge && options.logger) {
    window.__pcaWebBridge.applyLogger(options.logger);
  } else if (!window.__pcaWebBridge) {
    window.__pcaWebBridge = new WebBridge(options);
  }
  return window.__pcaWebBridge;
}
//# sourceMappingURL=bridge_web.js.map